import React from 'react';

export function NewHDOrganDonation() {
  return (
    <div className="new-ha-organ-donation">
      <h1>Organ Donation</h1>
      <p>Specify your preferences regarding organ and tissue donation.</p>
    </div>
  );
}